import type { AppStateController } from '../AppStateController';

export function getLivesToRefill(stateController: AppStateController): number {
  return Math.max(stateController.getLivesMax() - stateController.getLives(), 0);
}
